// extracted by mini-css-extract-plugin
export default {"penalty":"PenaltyNotification_penalty__3XrTX"};